const data = {
  func: {
    title: "商品与服务",
    subtitle: "丰富的商品·优质的服务",
    bg:
      "https://img14.360buyimg.com/imagetools/jfs/t1/144492/36/10727/421531/5f819979Ebcd4b83f/9817c24505b3ef00.png",
  },
  style: {},
  data: {
    getData: {
      data: {
        data: [
          {
            title: "精选优质商品",
            link:
              "https://img12.360buyimg.com/imagetools/jfs/t1/123999/12/14775/3843/5f817fc1Ec807fcbc/05c8884d323f869d.png",
          },
          {
            title: "商品池定制",
            link:
              "https://img13.360buyimg.com/imagetools/jfs/t1/129437/38/14612/5710/5f817fc1E890fa316/fc599f930b6f8efa.png",
          },
          {
            title: "解决方案定制",
            link:
              "https://img11.360buyimg.com/imagetools/jfs/t1/111150/31/20031/3142/5f817fc1E46055c99/ba83778957b46262.png",
          },
          {
            title: "智能财务对账结算",
            link:
              "https://img10.360buyimg.com/imagetools/jfs/t1/140837/22/10404/1513/5f817fc1E9861b567/527c2d1d2be9a38b.png",
          },
          {
            title: "企业专享协议价格",
            link:
              "https://img12.360buyimg.com/imagetools/jfs/t1/153964/39/1868/6356/5f817fc1E4ad7ba8c/ec93ad2507fab015.png",
          },
          {
            title: "企业专属配送服务",
            link:
              "https://img10.360buyimg.com/imagetools/jfs/t1/126998/4/14709/2738/5f817fc1Ef867e645/35ec3d5b2f83888a.png",
          },
          {
            title: "企业专属运营服务",
            link:
              "https://img12.360buyimg.com/imagetools/jfs/t1/137605/21/10501/5099/5f817fc1E39df927b/468809fff2eae257.png",
          },
          {
            title: "企业专属客服服务",
            link:
              "https://img13.360buyimg.com/imagetools/jfs/t1/116100/27/19822/5557/5f817fc1E54d6b7e9/858b153f6884d9a7.png",
          },
        ],
      },
      filter: "() => {}",
    },
  },
};
export default data;
